export function getStatusType(status: string | number) {
  switch (status) {
    case "0":
    case 0:
      return "Doesn't exist";
    case "1":
    case 1:
      return "Valid";
    case "2":
    case 2:
      return "Revoked";
    case "3":
    case 3:
      return "Expired";
    case "5":
    case 5:
      return "Suspended";
    default:
      break;
  }
}

export function getCardType(cardNumber: string) {
  const cardType = cardNumber.startsWith("61038") ? "Debit" : "Prepaid";
  return cardType;
}

export function formatCardNumber(cardNumber: string, spaceSize = 1) {
  if (cardNumber) {
    const spaces = " ".repeat(spaceSize);
    return cardNumber.replace(/(\d{4})(?=\d)/g, function (match) {
      return match + spaces;
    });
  } else return "";
}

export function mapHederaTransactions(txs: any, accountId: string) {
  console.log(`mapHederaTransactions txs: `, txs);
  const txsFiltered = txs.filter(
    (tx: any) =>
      tx.name === "CRYPTOTRANSFER" &&
      tx.token_transfers &&
      tx.token_transfers.length > 0 &&
      tx.token_transfers.find((token: any) => token.token_id === "0.0.429274"),
  );
  console.log(`mapHederaTransactions txsFiltered: `, txsFiltered);
  const transactionsMapped = txsFiltered.map((tx: any) => {
    const amount = tx.token_transfers.find(
      (tx: any) => tx.account === accountId,
    ).amount;
    const from = tx.token_transfers.find(
      (tx: any) => tx.account !== accountId,
    ).account;
    return {
      txId: tx.transaction_id,
      from: from,
      hash: tx.transaction_hash,
      account: accountId,
      value: Math.abs(amount) / 1000000,
      dir: amount > 0 ? "in" : "out",
      time: tx.valid_start_timestamp.split(".")[0],
      status: "Confirmed",
    };
  });

  console.log(`mapHederaTransactions transactionsMapped: `, transactionsMapped);

  return transactionsMapped;
}

export function isNoAddress(address: string) {
  return (
    !address ||
    address === "0x" ||
    address.toLowerCase() === "0x0000000000000000000000000000000000000000"
  );
}
